import { Box, SkeletonLine } from '@wix/design-system';
import React from 'react';
import { AppGridSkeleton } from '../app-grid';
import type { AppBoxSkin } from '../../components/app-box/app-box.types';

export interface AppSectionSkeletonProps {
  boxCount: number;
  minColumns?: 1 | 2 | 3 | 4;
  columns?: 1 | 2 | 3 | 4;
  skin?: AppBoxSkin;
}

export function AppSectionSkeleton({
  boxCount,
  minColumns,
  columns,
  skin = 'default',
}: AppSectionSkeletonProps) {
  return (
    <Box
      dataHook="skeleton-category-section"
      marginTop={skin === 'slim' ? '0px' : '24px'}
      direction="vertical"
      width="100%"
    >
      <Box align="space-between">
        <SkeletonLine width="48px" />
        <SkeletonLine width="100px" />
      </Box>
      <Box direction="vertical" marginTop="12px">
        <AppGridSkeleton
          dataHook="skeleton-apps"
          boxCount={boxCount}
          minColumns={minColumns}
          columns={columns}
          skin={skin}
        />
      </Box>
    </Box>
  );
}
